import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection } from '../components/LegalLayout';

export default function TermsAndConditions() {
  return (
    <LegalLayout eyebrow="Legal" title="Terms & Conditions" updated="August 8, 2026">
      <LegalSection title="1. Agreement to Terms">
        <p>
          These Terms &amp; Conditions ("Terms") govern your access to and use of Tech Dynasty
          (the "Game"), including our website, mobile apps, and related services (together, the
          "Service"), operated by the Tech Dynasty team ("we", "us", "our"). By creating an
          account or using the Service, you agree to these Terms. If you don't agree, please
          don't use the Service.
        </p>
      </LegalSection>

      <LegalSection title="2. Eligibility & Accounts">
        <p>
          You must be at least 13 years old to create an account. If you're under the age of
          majority in your jurisdiction, you should review these Terms with a parent or guardian.
        </p>
        <p>
          You're responsible for keeping your login credentials secure and for all activity under
          your account. Let us know immediately if you suspect unauthorized access.
        </p>
      </LegalSection>

      <LegalSection title="3. The Game & Virtual Items">
        <p>
          Tech Dynasty is a simulation game. In-game currency, resources, companies, upgrades,
          and other virtual items ("Virtual Items") have no real-world monetary value, cannot be
          redeemed for cash, and exist only within the Service. We may adjust, rebalance, or
          remove Virtual Items and features at any time as part of normal game development.
        </p>
      </LegalSection>

      <LegalSection title="4. Purchases">
        <p>
          Some features may be available through optional in-app purchases (e.g. premium
          currency, cosmetic themes, convenience upgrades, or expansion packs) or rewarded ads.
          Purchases are processed by the applicable app store or payment provider and are subject
          to their terms and refund policies.
        </p>
      </LegalSection>

      <LegalSection title="5. Acceptable Use">
        <p>You agree not to:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Cheat, exploit bugs, use bots, or manipulate the Service for unfair advantage.</li>
          <li>Reverse engineer, decompile, or attempt to extract the source code of the Service.</li>
          <li>Use the Service for any unlawful, abusive, or harmful purpose.</li>
          <li>Sell, trade, or transfer your account or Virtual Items outside the Service.</li>
        </ul>
        <p>
          We may suspend or terminate accounts that violate these rules, at our discretion.
        </p>
      </LegalSection>

      <LegalSection title="6. Intellectual Property">
        <p>
          Tech Dynasty, its logo, art, characters, and game content are owned by us or our
          licensors and protected by intellectual property laws. These Terms don't grant you any
          ownership rights — only a limited, personal, non-transferable license to use the
          Service for your own entertainment.
        </p>
      </LegalSection>

      <LegalSection title="7. Disclaimers">
        <p>
          The Service is provided "as is" without warranties of any kind. We don't guarantee the
          Service will be uninterrupted, error-free, or that saved progress will never be lost —
          though we take reasonable steps to protect your data.
        </p>
      </LegalSection>

      <LegalSection title="8. Limitation of Liability">
        <p>
          To the fullest extent permitted by law, we are not liable for any indirect, incidental,
          or consequential damages arising from your use of the Service, including loss of
          in-game progress or Virtual Items.
        </p>
      </LegalSection>

      <LegalSection title="9. Changes to These Terms">
        <p>
          We may update these Terms from time to time. If we make material changes, we'll update
          the "Last updated" date above. Continued use of the Service after changes take effect
          means you accept the revised Terms.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact Us">
        <p>
          Questions about these Terms? Visit our Support page at{' '}
          <Link to="/support" className="font-bold text-[var(--brand-primary)] hover:underline">
            playtechdynasty.com/support
          </Link>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
